import React from 'react';
import styled from 'styled-components';

const Loading = () => {
  return (
    <LoadingWrap>
      <div class='loadingio-spinner-ball-5dm0philucs'>
        <div class='ldio-wajl53dl1x'>
          <div></div>
        </div>
      </div>
    </LoadingWrap>
  );
};


const LoadingWrap = styled.div`
  @keyframes ldio-wajl53dl1x {
    0%,
    100% {
      animation-timing-function: cubic-bezier(0.45, 0, 0.9, 0.55);
    }
    0% {
      transform: translate(0, 0);
    }
    50% {
      transform: translate(0, 108px);
      animation-timing-function: cubic-bezier(0, 0.45, 0.55, 0.9);
    }
    100% {
      transform: translate(0, 0);
    }
  }

  .ldio-wajl53dl1x div {
    position: absolute;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: #ffa500;
    left: 74px;
    top: 20px;
    animation: ldio-wajl53dl1x 1s linear infinite;
  }
  .loadingio-spinner-ball-5dm0philucs {
    width: 200px;
    height: 200px;
    display: inline-block;
    overflow: hidden;
    background: ${({ theme }) => theme.body};
  }
  .ldio-wajl53dl1x {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(1);
    backface-visibility: hidden;
    transform-origin: 0 0;
  }
  .ldio-wajl53dl1x div {
    box-sizing: content-box;
  }
`;

export default Loading;
